function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 7.33333H14.6327C14.32 4.18333 11.8167 1.68 8.66667 1.36667V0H7.33333V1.36667C4.18333 1.68 1.68 4.18333 1.36733 7.33333H0V8.66667H1.36733C1.68 11.8167 4.18333 14.32 7.33333 14.6333V16H8.66667V14.6333C11.8167 14.3207 14.32 11.8167 14.6327 8.66667H16V7.33333ZM8.66667 13.2873V10.6667H7.33333V13.2873C4.926 12.9847 3.01467 11.074 2.71267 8.66667H5.33333V7.33333H2.71267C3.01467 4.926 4.926 3.01533 7.33333 2.71267V5.33333H8.66667V2.71267C11.074 3.01533 12.9853 4.92533 13.2873 7.33333H10.6667V8.66667H13.2873C12.9853 11.074 11.074 12.9847 8.66667 13.2873ZM9.33333 8C9.33333 8.736 8.736 9.33333 8 9.33333C7.264 9.33333 6.66667 8.736 6.66667 8C6.66667 7.264 7.264 6.66667 8 6.66667C8.736 6.66667 9.33333 7.264 9.33333 8Z",
  fill: "current"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgIconmonstrCrosshair61 = function SvgIconmonstrCrosshair61(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconmonstrCrosshair61, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconmonstr-crosshair-6 1.1051812f.svg";
export { ForwardRef as ReactComponent };